<div class="d-flex justify-content-center align-items-center flex-column p-4" *ngIf="!emptyArray">
  <h2><strong>Selecciona el servicio o alineadores</strong> que deseas agregar</h2>

  <div style="width: 90%;" class="py-4">
    <div *ngFor="let item of services; index as i">
      <div class="card mb-3" *ngIf="!item.added && item.show">
        <mat-checkbox  [(ngModel)]="item.checked" (ngModelChange)="onSelectService()" class="checkbox-card"></mat-checkbox>
        <div class="row g-0">
          <div class="col-md-2">
            <img src="{{item.imgUrl}}" class="img-fluid rounded-start" alt="Caso complejo">
          </div>
          <div class="col-md-10">
            <div class="card-body d-flex flex-column h-100">
              <h5 class="card-title mb-0">{{item.title}}</h5>
              <p class="card-text text-decoration-underline mb-3 text-muted fs-md">{{item.price | currency:currencyType:'symbol'}} {{i == 2? 'c/u':''}}</p>
              <p class="card-text fs-md" [innerHTML]="item.description"></p>
              <div *ngIf="i==2">
                <!--Show the spinner if the additional service is: Extra aligners-->
                <app-integer-spinner #additionalAlignerSpinner class="myadditionalalignerspinner" (valueChanged)="countAdditionalAlignerChanged($event)"></app-integer-spinner>
              </div>
              <div *ngIf="i==3">
                <!--Show the mat-select if the additional service is: Upgrade-->
                <mat-form-field >
                  <mat-label>Nuevo paquete</mat-label>
                  <mat-select style="min-width:150px" name="upgradeProduct" id="upgradeProduct" [(ngModel)]="upgradeProduct" (selectionChange)="onSelectionUpgradeChange()">
                    <mat-option *ngFor="let newProduct of products" [value]="newProduct">{{newProduct.name}} con {{newProduct.alignersQuantity == 0 ? 'ilimitados' : newProduct.alignersQuantity}} alineadores, ${{newProduct.finalPrice}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <button class="button secondary-button mt-3 align-self-end" style="min-width: 150px;" (click)="onAddService(item)">Agregar</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex flex-column align-items-end gap-3">
      <p class="fs-md">{{totalAmount | currency:currencyType:'symbol'}}</p>
      <button mat-button class="button secondary-button" (click)="onClickProcessPurchase()">Procesar Compra <mat-icon>chevron_right</mat-icon></button>
    </div>
  </div>
</div>

<div *ngIf="emptyArray">
  <div class="w-50 d-flex flex-column justify-content-center align-items-center mx-auto gap-3">
    <h2>¡Ya cuentas con todos los servicios adicionales!</h2>
    <img class="w-50 mx-auto mb-3" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/undraw/undraw-notify.svg" alt="Notificación imagen">
  </div>
</div>

<app-dialog #createNewSetupDialog [enableCloseDialogButton]="false" [preventCloseFromBackDrop]="true" width="70%">
  <div class="w-50 p-3 d-flex flex-column justify-content-center align-items-center mx-auto gap-3" *ngIf="!createNewSetup">
    <div>
      <h2 class="col text-center">Est&aacute;s a punto de comprar alineadores adicionales. Este producto requiere la creaci&oacute;n de un nuevo setup. &#191;Desea continuar?</h2>
    </div>
    <img class="w-50 mx-auto" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/undraw/undraw-notify.svg" alt="Notificación imagen">
    <div class="d-flex gap-3">
      <button type="button" class="button secondary-button" (click)="createNewSetup = true">Continuar el proceso</button>
      <button type="button" class="button danger-button" (click)="onCancelChooseSetup()">Cancelar</button>
    </div>
  </div>
  <div *ngIf="createNewSetup">
    <app-client-crud-setup [stageNumber]="currentNewStageId"></app-client-crud-setup>
  </div>
  <div *ngIf="createNewSetup" class="mb-3" style="text-align: center;">
    <ng-container *ngIf="!isSetupCompleted">
      <button *ngIf="!isSetupCompleted" type="button" class="button danger-button" (click)="onCancelChooseSetup()">Cancelar</button>
    </ng-container>
  </div>
  <div *ngIf="isSetupCompleted" class="w-50 d-flex justify-content-center align-items-center mx-auto gap-5 mb-5">
    <div>
      <button type="button" class="button danger-button" (click)="onCancelChooseSetup()">Cancelar</button>
    </div>
    <div>
      <button type="button" class="button secondary-button" (click)="onContinueSetup()">Confirmar y pagar</button>
    </div>
  </div>
</app-dialog>


<app-dialog #confirmDeleteCurrentCart [enableCloseDialogButton]="true" [preventCloseFromBackDrop]="true" [hasCallBack]="true" [callBackFunction]="onPreProcessPurchase.bind(this)" confirmButtonText="Aceptar" confirmButtonClass="button danger-button rounded" height="60%" width="90%">
  <div>
    <div class="w-50 mx-auto d-flex flex-column gap-5 p-4">
      <h2 class="col text-center">Para continuar con el proceso de compra, es necesario eliminar los productos del Carrito<strong> ¿Desea continuar?</strong></h2>
      <img class="w-50 mx-auto" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/undraw/undraw-notify.svg" alt="Notificación imagen">
    </div>
  </div>
</app-dialog>
